<div class="sticky" *ngIf="annoucement.active">
  <div><span class="sticky-header"><b>SCORE Announcement</b></span>- {{annoucement.message}}</div>
</div>
